import { render, staticRenderFns } from "./ViewImageForm.vue?vue&type=template&id=73f26664&scoped=true&"
import script from "./ViewImageForm.vue?vue&type=script&lang=js&"
export * from "./ViewImageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f26664",
  null
  
)

export default component.exports